var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRappel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.0533 29.8533L20.0693 29.8627C21.4855 30.7643 23.1668 31.1559 24.8356 30.9729C26.5044 30.7899 28.0609 30.0431 29.248 28.856L30.28 27.824C30.7409 27.3625 30.9998 26.7369 30.9998 26.0847C30.9998 25.4324 30.7409 24.8068 30.28 24.3453L25.932 20C25.4705 19.5391 24.8449 19.2802 24.1927 19.2802C23.5404 19.2802 22.9148 19.5391 22.4533 20V20C22.2251 20.2285 21.9541 20.4098 21.6557 20.5335C21.3574 20.6571 21.0376 20.7208 20.7147 20.7208C20.3917 20.7208 20.0719 20.6571 19.7736 20.5335C19.4752 20.4098 19.2042 20.2285 18.976 20L12.0187 13.0413C11.5577 12.5798 11.2988 11.9543 11.2988 11.302C11.2988 10.6498 11.5577 10.0242 12.0187 9.56267V9.56267C12.2472 9.33445 12.4284 9.06342 12.5521 8.76508C12.6758 8.46675 12.7395 8.14696 12.7395 7.824C12.7395 7.50105 12.6758 7.18126 12.5521 6.88292C12.4284 6.58459 12.2472 6.31356 12.0187 6.08534L7.67199 1.73334C7.21049 1.27241 6.5849 1.01352 5.93265 1.01352C5.2804 1.01352 4.65482 1.27241 4.19332 1.73334L3.16132 2.76534C1.97442 3.95251 1.22774 5.50886 1.04448 7.17755C0.861227 8.84624 1.25235 10.5275 2.15332 11.944L2.16399 11.96C6.92854 19.0131 13.0013 25.0872 20.0533 29.8533V29.8533Z",
    stroke: "#7E8EAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRappel);
export default __webpack_public_path__ + "static/media/rappel.c04faa653319f14e3eaf8cfeb6d35d31.svg";
export { ForwardRef as ReactComponent };